/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CharCriteriaInput
 */
export interface CharCriteriaInput {
    /**
     * 
     * @type {boolean}
     * @memberof CharCriteriaInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CharCriteriaInput
     */
    value?: string;
}

export function CharCriteriaInputFromJSON(json: any): CharCriteriaInput {
    return CharCriteriaInputFromJSONTyped(json, false);
}

export function CharCriteriaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharCriteriaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function CharCriteriaInputToJSON(value?: CharCriteriaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': value.value,
    };
}


